import BudgetPrice from '@/domains/BudgetPrices/BudgetPrice';
import RpcService from "@/core/services/Rpc/RpcService";
import type RpcResponse from "@/core/services/Rpc/RpcResponse";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import RpcDataSort from "@/core/services/Rpc/RpcDataSort";
import type DateSimple from "@/core/types/DateSimple";

/**
 * DAO для работы с бюджетными ценами.
 * Все методы делают запросы к серверу через RPC.
 */
class BudgetPricesDAO {

  /** Цена, действующая на дату; без даты — на сегодня */
  static async get(productId: number, date?: DateSimple): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.get', { productId, date });
  }

  /** Все записи по номенклатуре — прошлые, действующая и будущие */
  static async getHistory(productId: number): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.getHistory', { productId });
  }

	/**
	 * Загружает список бюджетных цен.
	 * @param filters    — фильтры
   * @param pagination — пагинация датагрида
   * @param sort       — сортировка датагрида
	 */
	static async getList(
    filters: {
      productIds?: number | number[],
      code?:       string,
      date?:       DateSimple,
    },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort
  ): Promise<RpcResponse> {

    let productIds = undefined;
    if (filters?.productIds) {
      if (Array.isArray(filters.productIds)) {
        productIds = filters.productIds;
      }
      else {
        productIds = [filters.productIds];
      }
    }

    return RpcService.makeRequest(
      'budgetPrices.getList',
      {
        ...filters,
        productId: productIds
      },
      pagination,
      sort
    );
	}

	/**
	 * Создаёт новую запись бюджетной цены. Записи не редактируются — изменение цены или объёма тоже идёт сюда
	 */
	static async add(budgetPrice: BudgetPrice): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.add', { budgetPrice });
	}

	/**
	 * Удаляет запись бюджетной цены
	 */
	static async delete(budgetPrice: BudgetPrice, reasonText: string | null = null): Promise<RpcResponse> {
    return RpcService.makeRequest('budgetPrices.delete', { budgetPrice, reasonText });
	}
}

export default BudgetPricesDAO;